import { live_video_streamingService } from '../_services';

const state = { onRequest: false, live_video_streaming: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        live_video_streamingService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  live_video_streaming: state => {
    return state.live_video_streaming
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.live_video_streaming = [];
    },
    success(state) {
      state.onRequest = false;
    },
    clear_data(state) {
      state.onRequest = false;
      state.live_video_streaming = [];
    },
    success_data(state, data) {
      state.onRequest = false;
      state.live_video_streaming = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const live_video_streamings = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
